var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"special-events-list",class:{ 'has-bullet-points': _vm.items.length > 1 }},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,class:[item.className, 'small-text']},[_vm._v(_vm._s(item.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }